import React, { Component } from 'react';
import SelectInput from '../selectInput';
import ReactGA from 'react-ga';
import { translate } from 'react-i18next';

class OtherApplication extends Component {
  constructor(props) {
    super(props);

    const applications = this.props.application.applications;
    let options = [];
    let title = '';
    let selected = null;

    if (applications.length > 1) {
      if (applications[0].c_option_display) {
        title = applications[0].c_option_display;
      } else {
        title = applications[0].name;
      }

      applications.map((element) => {
        const option = element.c_option || element.display_name;
        return options.push({
          value: option,
          label: option,
        });
      });
    }

    this.state = {
      selected,
      options,
      title,
    };
  }

  // return the change intervals for the engine
  getOCI = (app) => {
    let text = '';
    const { t, equipment } = this.props;

    return equipment.change_interval
      .filter((i) => Number(i.application_id) === app.id)
      .map((x) => {
        if (x.intervals.length === 1) {
          text = x.intervals[0].value + x.intervals[0].unit;
        } else {
          text =
            x.intervals[0].value +
            x.intervals[0].unit +
            ' / ' +
            x.intervals[1].value +
            x.intervals[1].unit;
        }

        return (
          <p className="oci" key={x.application_id}>
            <span className="title">{t('vehicle_spec.oci')}</span>
            <span>{text}</span>
          </p>
        );
      });
  };

  // change transmission selection
  handleChange = (selected) => {
    this.setState({ selected: selected.value });
  };

  // Create select if multiple engine transmissions
  getSelectInput = (title, options) => {
    let selectedIndex = options.findIndex((element) => element.value === this.state.selected);
    const selected = options[selectedIndex];

    ReactGA.event({
      category: this.props.selectedFamily,
      action: 'Results',
      label: 'Engine Selection',
    });

    return (
      <SelectInput
        key={options.value}
        title={title}
        value={selected}
        simpleValue={true}
        handleChange={this.handleChange}
        options={options}
      />
    );
  };

  render() {
    const { t, application, equipment } = this.props;
    const { title, selected, options } = this.state;
    const optionTitle = title.toLowerCase();

    if (options.length && !selected) {
      return (
        <section className="other">
          <div className="other__header">
            <div className="other__title">
              <p className="title">{application.applications[0].name}:</p>
              <p className="instruction">
                {t('result_page.option').replace('#OPTION#', optionTitle)}
              </p>
            </div>
          </div>
          <div className="other__filters">{this.getSelectInput('', options)}</div>
        </section>
      );
    }

    return application.applications.map((app) => {
      if (
        app.c_option === this.state.selected ||
        app.display_name === this.state.selected ||
        this.props.application.applications.length === 1
      ) {
        return (
          <section className="other" key={app.name}>
            <div className="other__header">
              <div className="other__title">
                <p className="title">{app.name}</p>
              </div>
              <div className="other__filters">
                {options.length ? this.getSelectInput(title, options) : ''}
              </div>
            </div>
            {equipment.change_interval ? this.getOCI(app) : ''}
            {app.capacity ? (
              <p className="capacity">
                <span className="title">{t('vehicle_spec.capacity')}&nbsp;</span>
                <span>{app.capacity + ' ' + equipment.model.capacity_unit}</span>
              </p>
            ) : (
                ''
              )}
            {app.note_refs
              ? app.note_refs.map((note) => {
                return (
                  <div key={note['note_index']} className="note-ref">
                    <p className="title">{t('result_page.notes_ref')}</p>
                    <p>{note['note_index']}</p>
                  </div>
                );
              })
              : ''}
            {app.products &&
              app.products.map((product, i) => {
                return (
                  <div className="product" key={product.name}>
                    <p className="tier-name">{t('tier_names', { returnObjects: true })[i]}</p>
                    <p className="product-name">{product.name}</p>
                  </div>
                );
              })}
          </section>
        );
      } else {
        return false;
      }
    });
  }
}

export default translate('translations')(OtherApplication);



// WEBPACK FOOTER //
// ./src/components/results/OtherApplication.js